module.exports = __webpack_public_path__ + "img/366.9e8397c4.png";